import { render, staticRenderFns } from "./AddMemberSidebar.vue?vue&type=template&id=672d2454"
import script from "./AddMemberSidebar.vue?vue&type=script&lang=js"
export * from "./AddMemberSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports